import { render, staticRenderFns } from "./index.vue?vue&type=template&id=be5659ca&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./assets/lanhu-style.css?vue&type=style&index=0&id=be5659ca&prod&scoped=true&lang=css&external"
import style1 from "./index.vue?vue&type=style&index=1&id=be5659ca&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be5659ca",
  null
  
)

export default component.exports